import { useEffect, useState } from "react";
import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material";
import { API_URL } from "src/utils/apiUrl";

export default function Health() {
    const [state, setState] = useState({ status: "loading", data: null, error: null });

    useEffect(() => {
        let cancelled = false;
        fetch(`${API_URL}/health`)
            .then((r) => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.json();
            })
            .then((data) => {
                if (!cancelled) setState({ status: "ok", data, error: null });
            })
            .catch((err) => {
                if (!cancelled) setState({ status: "err", data: null, error: err.message });
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <Stack spacing={3}>
            <Typography variant="h4" component="h1">Health check</Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>Pinging <code>{API_URL}/health</code></Typography>
            {state.status === "loading" && <CircularProgress size={24} />}
            {state.status === "ok" && (
                <Alert severity="success">
                    <Box component="pre" sx={{ m: 0, fontSize: 13 }}>{JSON.stringify(state.data, null, 2)}</Box>
                </Alert>
            )}
            {state.status === "err" && (
                <Alert severity="error">Backend not reachable: {state.error}</Alert>
            )}
        </Stack>
    );
}
